import { createRoot } from 'react-dom/client';
import { configurePanelApi } from './application/panelApi';
import { configureLiveConnection } from './application/liveConnection';
import { App } from './App';
import { browserLiveConnection } from './infrastructure/browserLiveConnection';
import { BrowserPanelApi } from './infrastructure/browserPanelApi';
import { applyStoredTheme } from './lib/theme';
import { AppProvider } from './store/AppContext';
import './styles/app.css';

applyStoredTheme();
configurePanelApi(BrowserPanelApi);
configureLiveConnection(browserLiveConnection);

const root = document.getElementById('root');
if (!root) throw new Error('#root not found');


createRoot(root).render(
  <AppProvider>
    <App />
  </AppProvider>,
);
